import * as Phaser from "phaser-ce"
import { ActivityKey } from "../../../../shared/models/ActivityKey"
import { BackgroundSprite } from "../../../generic-sprites/BackgroundSprite"
import { Buttons } from "../../../generic-sprites/Buttons"
import { loadGenericAssets } from "../../../generic-sprites/GenericAssets"
import { ThrobberSprite } from "../../../generic-sprites/ThrobberSprite"
import { AudioSync } from "../../../utils/AudioSync"
import { PhaserUtils } from "../../../utils/PhaserUtils"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { SecondHandRepo } from "../SecondHandRepo"
import { loadSharedAssets, SharedSecondHandAssets } from "../SharedSecondHandAssets"
import { LongPos } from "./LongPos"
import { loadAssets, LongTermAssets } from "./LongTermAssets"

export class LongTermState extends Phaser.State {

    private static readonly BOX_SCALE = 0.8
    private static readonly RAT_SCALE = 0.8

    rat: Phaser.Sprite
    dyingRat: Phaser.Sprite
    intro: Phaser.Sound
    ratBox: Phaser.Sprite

    preload() {
        loadAssets(this.game)
        loadSharedAssets(this.game)
        loadGenericAssets(this.game)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)

        this.game.add.existing(new BackgroundSprite(this.game, LongTermAssets.BACKGROUND))

        this.ratBox = this.game.add.sprite(LongPos.transparentBoxX(), LongPos.transparentBoxY(), LongTermAssets.RAT_BOX)
        Scale.scaleSprite(this.ratBox, LongTermState.BOX_SCALE)

        this.rat = new Phaser.Sprite(this.game, LongPos.ratX(), LongPos.ratY(), LongTermAssets.RAT)
        Scale.scaleSprite(this.rat, LongTermState.RAT_SCALE)
        const ratMove = this.rat.animations.add("move",
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 11, 11, 10, 10, 9,
                9, 10, 10, 11, 11, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1])
        ratMove.play(8, true)
        this.game.add.existing(this.rat)

        this.dyingRat = this.game.add.sprite(0, 0, LongTermAssets.RAT_DYING)
        Scale.scaleSprite(this.dyingRat, LongTermState.RAT_SCALE)
        Sprites.centerSpriteInSprite(this.rat, this.dyingRat)
        this.dyingRat.alpha = 0

        const transparentBox = this.game.add.sprite(LongPos.transparentBoxX(), LongPos.transparentBoxY(), SharedSecondHandAssets.BOX_FRONT)
        Scale.scaleSprite(transparentBox, LongTermState.BOX_SCALE)

        this.setupTimers()
    }

    setupTimers = () => {
        this.intro = this.game.add.audio(LongTermAssets.INTRO)
        const timer = new AudioSync(this.game, this.intro)
        this.intro.onStop.add(this.onIntroDone, this)
        this.intro.play()

        const smoke = new ThrobberSprite(this.game, LongPos.smokeX(), LongPos.smokeY(), LongTermAssets.SMOKE, 1)

        timer.add(5000, () => {
            this.game.add.existing(smoke)
            smoke.throb(0, null, 60, 0.15)
        })

        timer.add(10000, () => {
            const boxSmoke = this.game.add.sprite(LongPos.transparentBoxX(), LongPos.transparentBoxY(), SharedSecondHandAssets.BOX_SMOKE)
            Scale.scaleSprite(boxSmoke, LongTermState.BOX_SCALE)
            boxSmoke.alpha = 0
            Sprites.fade(boxSmoke, {fadeDuration: 2000})
        })
        timer.start()
    }

    onIntroDone = () => {
        Buttons.makeSpriteButton(this.ratBox)
        this.ratBox.events.onInputDown.addOnce(() => {
            Sprites.fadeOut(this.rat)
            Sprites.fade(this.dyingRat)
            const ratDeathAudio = this.game.add.audio(LongTermAssets.RAT_DEATH_AUDIO)
            ratDeathAudio.play()

            const ratDeathTimer = this.game.time.create()
            ratDeathTimer.add(1000, () => {
                this.dyingRat.animations.frame = 1
            })
            ratDeathTimer.add(3000, () => {
                this.dyingRat.animations.frame = 2
            })
            ratDeathTimer.add(6000, () => {
                SecondHandRepo.instance.setLongTermAsComplete()
                this.game.state.start(ActivityKey.SECOND_HAND)
            })
            ratDeathTimer.start()

        })
    }

}
